import script from "./RechargePage.vue?vue&type=script&setup=true&lang=js"
export * from "./RechargePage.vue?vue&type=script&setup=true&lang=js"

import "./RechargePage.vue?vue&type=style&index=0&id=2ae1326c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ae1326c"]])

export default __exports__